import { FitnessLevel } from './user';

export const COMPLEXITY_LEVELS_ARR = Object.values(FitnessLevel);

export const DEFAULT_VOLUME = 0.4;
export const DEFAULT_BACKGROUND_VOLUME = 0.1;
export const VOLUME_KEY_IN_LS = 'workout-volume';
